import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/branch.actions'
import { Select } from 'antd'

class Branches extends PureComponent {
    componentDidMount() {
        // if (this.props.branches.length === 0) {
        //     this.props.actions.fetchBranchList()
        // }
    }

    render() {
        if (this.props.selectedBranches) {
            return (
                <Select
                    mode="multiple"
                    allowClear
                    style={{
                        width: '100%',
                    }}
                    placeholder="Select branches"
                    defaultValue={[]}
                    onChange={this.props.handleChange}
                    options={this.props.branches}
                    value={this.props.selectedBranches}
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                />
            )
        } else {
            return (
                <Select
                    mode="multiple"
                    allowClear
                    style={{
                        width: '100%',
                    }}
                    placeholder="Select branches"
                    defaultValue={[]}
                    onChange={this.props.handleChange}
                    options={this.props.branches}
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                />
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        branches: state.BranchReducer.branchList,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Branches)
